import { Badge } from 'primereact/badge';

type StrippingProgressProps = {
  total: number;
  completed: number;
};

export const StrippingProgress = ({
  total,
  completed,
}: StrippingProgressProps) => {
  return (
    <Badge
      value={`${completed} / ${total}`}
      severity={total === completed ? 'success' : null}
      size="large"
    />
  );
};
